import { Component } from '@angular/core';

@Component({
  selector: 'app-catalog-import-export',
  templateUrl: './catalog-import-export.component.html',
  styleUrls: ['./catalog-import-export.component.scss'],
})
export class CatalogImportExportComponent {}
